/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".linkDisabled[_ngcontent-%COMP%]{cursor:not-allowed;pointer-events:none;color:grey}.strike[_ngcontent-%COMP%]{text-decoration:line-through}"];
export { styles as styles };
